import React from 'react'
import { useStateValue } from '@State'
import { QUESTION_COMPONENTS, UnsupportedQuestion } from './questions/questionRegistry'
import { NGNCasesetQuestion } from './questions/NGNCasesetQuestion'

export const QuestionList = () => {
  const [state] = useStateValue()
  const { questions } = state

  // Compute starting question number for each top-level item
  let counter = 1
  const startNumbers = questions.map(q => {
    const n = counter
    counter += q.type === 'caseset' ? (q.questions || []).length : 1
    return n
  })

  return (
    <ul className="list-unstyled">
      {questions.map((question, index) => {
        if (question.type === 'caseset') {
          return (
            <li key={question.guid} data-guid={question.guid} className="mb-3">
              <NGNCasesetQuestion question={question} startNumber={startNumbers[index]} />
            </li>
          )
        }
        const QuestionComponent = QUESTION_COMPONENTS[question.type] ?? UnsupportedQuestion
        return (
          <li key={question.guid} data-guid={question.guid} className="mb-3">
            <div className="card-myed">
              <QuestionComponent question={question} number={startNumbers[index]} />
            </div>
          </li>
        )
      })}
    </ul>
  )
}
